import { Store } from 'vuex'
import { VuexPersistentPlugin, VuexRestorePlugin } from 'app/store/plugins'
import { initializeModules } from 'app/store/accessor'

const initModules = (store: Store<any>) => initializeModules(store)

export const plugins = [initModules, VuexPersistentPlugin, VuexRestorePlugin]
